import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalInputImageUploadComponent } from '../modal-input-image-upload/modal-input-image-upload.component';

@Component({
  selector: 'app-input-image-upload',
  templateUrl: './input-image-upload.component.html',
  styleUrls: ['./input-image-upload.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class InputImageUploadComponent {
  @Input() idTrade: '';
  @Input() smartUp: boolean = true;
  @Input() productDivergenceEvidence = false;
  @Input() uploadedImageUrls: string[] = [];
  @Input() removingImageUrls: string[] = [];
  @Output() imageRemoved = new EventEmitter<string>();
  @Output() imagePreview = new EventEmitter<string>();
  @Output() uploadDialogClosed = new EventEmitter<void>();
  @Output() filesChanged = new EventEmitter<string[]>();
  maxAllowedImages = 4;
  constructor(private _dialog: MatDialog) {}
  imagePreviewUrlList: string[] = [];

  openDialog() {
    const dialogRef = this._dialog.open(ModalInputImageUploadComponent, {
      panelClass: 'custom-dialog-container',
      maxWidth: '95%',
      data: {
        idTrade: this.idTrade, smartUp: this.smartUp, model: 'tvf',
        ...(this.productDivergenceEvidence ? { productDivergenceEvidence: true } : {}),
      },
    });

    dialogRef.afterClosed().subscribe((result: string | boolean) => {
      if (typeof result === 'string') {
        this.imagePreviewUrlList.unshift(result as string);
        this.filesChanged.emit(this.imagePreviewUrlList);
      }
      this.uploadDialogClosed.emit();
    });
  }

  discardPhoto(url: string): void {
    this.imagePreviewUrlList = this.imagePreviewUrlList.filter((image) => image !== url);
    this.filesChanged.emit(this.imagePreviewUrlList);
  }

  removePhotoAt(index: number) {
    if (this.productDivergenceEvidence) {
      this.imageRemoved.emit(this.imagePreviewUrlList[index]);
      return;
    }
    this.imagePreviewUrlList = this.imagePreviewUrlList.filter((_, i) => i !== index);
    this.filesChanged.emit(this.imagePreviewUrlList);
  }
}
